<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true">{{ title }}</el-button>
    <template v-if="!isEdit">
      <el-button type="primary" @click="showFeigeNumbersDialog = true">从飞鸽创建销售订单</el-button>

      <el-dialog @open="handleOpenFeigeNumbersDialog" title="从飞鸽创建销售订单" :visible.sync="showFeigeNumbersDialog" append-to-body>
        <DynamicInputs v-model="feigeNumbers" :min="1" placeholder="请填写飞鸽订单号" />

        <template #footer>
          <el-button type="default" @click="showFeigeNumbersDialog = false">取消</el-button>
          <el-button type="primary" :disabled="validFiegeNumbers.length === 0" @click="handleSubmitFeigeNumbers">提交</el-button>
        </template>
      </el-dialog>
    </template>

    <el-dialog append-to-body title="选择聚水潭售后订单填充销售订单商品" :visible.sync="showJushuitanAfterSaleOrderDialog">
      <el-form>
        <el-form-item label="聚水潭售后" v-if="tableData[jushuitanAfterSaleOrderDialogRowIndex] && tableData[jushuitanAfterSaleOrderDialogRowIndex].customer_id">
          <app-read-options
            style="width: 100%;"
            size="mini"
            multiple
            v-model="jushuitanAfterSaleOrderIds"
            url="jushuitan_after_sales/read_options"
            label-field="display_text"
            :label-format="displayJushuitanAfterSaleOrderText"
            :params="{ customer_id_eq: tableData[jushuitanAfterSaleOrderDialogRowIndex].customer_id }"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="default" @click="showJushuitanAfterSaleOrderDialog = false">取消</el-button>
        <el-button type="primary" :disabled="jushuitanAfterSaleOrderIds.length === 0" @click="autoFillSalesLineItemsByAfterSaleOrder">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog
      v-loading="submitting"
      :title="title"
      append-to-body
      fullscreen
      :visible.sync="dialogVisible"
      custom-class="dialog-full-screen"
      @open="handleOpen"
      @closed="handleClosed"
    >
      <el-table :data="tableData" border size="mini" height="100%" ref="tableRef" :row-key="ensureTableRowKey">
        <el-table-column width="40" label="#" fixed="left" :resizable="false">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="kind" label="订单类型" min-width="200" :resizable="false">
          <template #default="scope">
            <el-select size="mini" v-model="tableData[scope.$index].kind" @change="handleKindChange(scope.$index, $event)">
              <el-option value="sample" label="样板" />
              <el-option value="bulk" label="大货" />
              <el-option value="after_sale" label="售后&退货" />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="product_type" label="产品类型" min-width="200" :resizable="false">
          <template #default="scope">
            <el-select size="mini" v-model="tableData[scope.$index].product_type">
              <el-option value="custom" label="定制" />
              <el-option value="stock" label="现货" />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="business_kind" label="业务类型" min-width="200" :resizable="false">
          <template #default="scope">
            <el-select size="mini" v-model="tableData[scope.$index].business_kind">
              <el-option value="custom" label="定制" />
              <el-option value="wholesale" label="批发" />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="customer_id" label="客户" min-width="240" :resizable="false">
          <template #default="scope">
            <app-read-options
              :key="tableData[scope.$index]._customer_id_key"
              style="width: 100%;"
              size="mini"
              v-model="tableData[scope.$index].customer_id"
              url="customers/read_options"
              label-field="name"
              :params="{ user_id_eq: $root.user.id }"
              @change="handleCustomerChange(scope.$index)"
              @select="handleCustomerSelect(scope.$index, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="ordered_on" label="下单日期" min-width="160" :resizable="false">
          <template #default="scope">
            <el-date-picker style="width: 100%" size="mini" v-model="tableData[scope.$index].ordered_on" type="date" value-format="yyyy-MM-dd" />
          </template>
        </el-table-column>
        <el-table-column prop="is_transfer_existing" label="是否调拨现货" min-width="120" :resizable="false">
          <template #default="scope">
            <el-checkbox v-model="tableData[scope.$index].is_transfer_existing" />
          </template>
        </el-table-column>
        <el-table-column label="售后订单" min-width="400">
          <template #default="scope">
            <template v-if="tableData[scope.$index].kind === 'after_sale'">
              <app-read-options
                style="width: 100%;"
                :key="`${tableData[scope.$index].customer_id}-${tableData[scope.$index]._source_id_key}`"
                :disabled="!tableData[scope.$index].customer_id"
                size="mini"
                v-model="tableData[scope.$index].source_id"
                url="sales_orders/read_options"
                label-field="display_text"
                :label-format="displaySalesOrderText"
                :params="{ customer_id_eq: tableData[scope.$index].customer_id, kind_in: ['sample', 'bulk'] }"
              />
              <el-button
                :disabled="!tableData[scope.$index].customer_id"
                style="margin-top: 10px;"
                size="mini"
                type="primary"
                @click="handleShowJushuitanAfterSaleOrderDialog(scope.$index)"
              >选择聚水潭售后订单填充销售订单商品</el-button>
            </template>
            <span v-else>订单类型 是 "售后&退货"时需要填写</span>
          </template>
        </el-table-column>
        <el-table-column prop="jushuitan_order_ids" label="聚水潭订单" min-width="600" :resizable="false">
          <template #default="scope">
            <template v-if="tableData[scope.$index].kind !== 'after_sale'">
              <FormItemJushuitanOrderIds
                :value.sync="tableData[scope.$index].jushuitan_order_ids"
                :disabled="!tableData[scope.$index].customer_id"
                :params="{ customer_id_eq: tableData[scope.$index].customer_id }"
                :key="tableData[scope.$index].customer_id"
                :onInitOptions="() => handleInitJushuitanOrderOptions(scope.$index)"
                @autoFill="autoFillSalesLineItems(tableData[scope.$index], $event)"
              />
            </template>
            <span v-else>订单类型 不是 "售后&退货"时需要填写</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" :resizable="false">
          <template #default="scope">
            <el-input size="mini" v-model="tableData[scope.$index].remark" type="textarea" :rows="2" />
          </template>
        </el-table-column>
        <el-table-column prop="sales_line_items.style_number" label="款号" class-name="table-cell-multiple-row" min-width="180" :resizable="false">
          <template #default="scope">
            <div class="cell-container">
              <div class="cell-item" :class="{ highlight: (item._highlights || []).includes('style_number') }" v-for="(item, index) in tableData[scope.$index].sales_line_items" :key="index">
                <el-input size="mini" v-model="tableData[scope.$index].sales_line_items[index].style_number">
                  <template #append>
                    <el-button :disabled="!item.style_number" icon="el-icon-search" size="mini" @click="handleSearchStyleNumber(item)" />
                  </template>
                </el-input>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sales_line_items.quantity" label="数量" class-name="table-cell-multiple-row" min-width="120" :resizable="false">
          <template #default="scope">
            <div class="cell-container">
              <div class="cell-item" :class="{ highlight: (item._highlights || []).includes('quantity') }" v-for="(item, index) in tableData[scope.$index].sales_line_items" :key="index">
                <el-input size="mini" v-model="tableData[scope.$index].sales_line_items[index].quantity" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sales_line_items.price" label="价格" class-name="table-cell-multiple-row" min-width="120" :resizable="false">
          <template #default="scope">
            <div class="cell-container">
              <div class="cell-item" :class="{ highlight: (item._highlights || []).includes('price') }" v-for="(item, index) in tableData[scope.$index].sales_line_items" :key="index">
                <el-input size="mini" v-model="tableData[scope.$index].sales_line_items[index].price" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sales_line_items" label="款号操作" class-name="table-cell-multiple-row" min-width="120">
          <template #default="scope">
            <div class="cell-container">
              <template v-if="tableData[scope.$index].sales_line_items.length > 0">
                <div class="cell-item" v-for="(item, index) in tableData[scope.$index].sales_line_items" :key="index">
                  <el-button type="text" @click="handleAddSalesLineItem(scope.$index)" v-if="index === tableData[scope.$index].sales_line_items.length - 1">添加款号</el-button>
                  <el-button type="text" @click="handleRemoveSalesLineItem(scope.$index, index)" v-if="tableData[scope.$index].sales_line_items.length > 1">删除</el-button>
                </div>
              </template>
              <div class="cell-item" v-else>
                <el-button type="text" @click="handleAddSalesLineItem(scope.$index)">添加款号</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="payment_reminders" label="交易方式/付款提醒" min-width="320" :resizable="false">
          <template #default="scope">
            <FormItemPaymentReminders
              :value="tableData[scope.$index].payment_reminders"
              :original-value="isEdit ? (value.payment_reminders || []) : []"
              :customer-transaction-id="tableData[scope.$index].customer_transaction_id"
              :customer-transactions="customerTransactions"
              :customer-transaction="tableData[scope.$index].customer_transaction"
              :sales-amount="calculateSalesAmount(tableData[scope.$index])"
              :is-edit="isEdit"
              :disabled="!tableData[scope.$index].customer_id"
              @change-customer-transaction-id="handleCustomerTransactionChange(scope.$index, $event)"
              @change-payment-reminders="handlePaymentRemindersChange(scope.$index, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="action" label="订单操作" min-width="120" v-if="!isEdit">
          <template #default="scope">
            <el-button type="text" @click="handleAddRow" v-if="scope.$index === tableData.length - 1">添加订单</el-button>
            <el-button type="text" v-if="tableData.length > 1" @click="handleRemoveRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <template #footer>
        <el-button type="default" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </template>
    </el-dialog>

    <DialogSalesOrder :visible.sync="showAfterSaleOrderDialog" @select="handleSelectedAfterSaleOrder" />
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { displayText } from '@/custom_models_extend';
import moment from 'moment';
import Schema from 'async-validator';
import _ from 'lodash';
import Decimal from 'decimal.js';
import DynamicInputs from '@/components/dynamic-input.vue';
import DialogSalesOrder from './components/dialog-sales-order.vue';
import FormItemJushuitanOrderIds from './components/form-item-jushuitan-order-ids.vue';
import FormItemPaymentReminders from './components/form-item-payment-reminders.vue';
import { allocateReminderAmounts } from './utils/payment-reminders';

@Component({
  components: {
    DynamicInputs,
    DialogSalesOrder,
    FormItemJushuitanOrderIds,
    FormItemPaymentReminders,
  }
})
export default class SalesOrdersForm extends Vue {
  @Prop({ type: Object }) value;

  displayText = displayText;
  tableData = []
  submitting = false;
  dialogVisible = false;
  feigeNumbers = [];
  showFeigeNumbersDialog = false;
  defaultRowFromFeige = null;
  showJushuitanAfterSaleOrderDialog = false;
  jushuitanAfterSaleOrderDialogRowIndex = null;
  jushuitanAfterSaleOrderIds = [];
  customerTransactions = [];
  customerTransactionsLoading = false;

  afterSaleOrderDialogRowIndex = null;
  showAfterSaleOrderDialog = false;

  @Watch('tableData', { deep: true })
  onTableDataChange() {
    // 表格内容是动态时，表格高度会有问题
    this.debounceDoLayout();
  }

  get isEdit() {
    return !!this.value;
  }

  get title() {
    return this.isEdit ? '编辑' : '创建销售订单';
  }

  get validFiegeNumbers() {
    return _.uniq(this.feigeNumbers.filter(item => item.trim()));
  }

  created() {
    this.debounceDoLayout = _.debounce(async () => {
      await this.$nextTick();
      this.$refs.tableRef.doLayout();
    }, 1000);
  }

  ensureTableRowKey(row) {
    return row.id || row.key;
  }

  handleInitJushuitanOrderOptions(rowIndex) {
    if (this.value) {
      return this.tableData[rowIndex].jushuitan_orders || [];
    }
  }

  handleOpen() {
    this.loadCustomerTransactions();
    if (this.value) {
      this.tableData = [this.normalizeRow(JSON.parse(JSON.stringify(this.value)))];
    } else {
      if (this.defaultRowFromFeige) {
        this.tableData = [this.normalizeRow({ ...this.getDefaultRow(), ...this.defaultRowFromFeige })];
      } else {
        this.tableData = [this.getDefaultRow()];
      }
    }
  }

  handleClosed() {
    this.defaultRowFromFeige = null;
  }

  getDefaultSalesLineItem() {
    return  {
      style_number: '',
      quantity: 0,
      price: 0,
    }
  }

  getDefaultRow() {
    return {
      key: +new Date(),
      ordered_on: moment().format('YYYY-MM-DD'),
      kind: '',
      product_type: '',
      business_kind: '',
      customer_id: '',
      source_id: '',
      is_transfer_existing: false,
      sales_line_items: [],
      jushuitan_order_ids: [],
      customer_transaction_id: '',
      customer_transaction: null,
      payment_reminders: [],
      remark: '',
    }
  }

  normalizeRow(row) {
    return {
      ...this.getDefaultRow(),
      ...row,
      payment_reminders: this.sortPaymentReminders(row.payment_reminders || []),
      customer_transaction: row.customer_transaction || null,
    };
  }

  sortPaymentReminders(paymentReminders = []) {
    return [...paymentReminders].sort((a, b) => Number(a.stage_index) - Number(b.stage_index));
  }

  getCustomerTransactionById(customerTransactionId) {
    if (!customerTransactionId) {
      return null;
    }

    return this.customerTransactions.find(item => Number(item.id) === Number(customerTransactionId)) || null;
  }

  async loadCustomerTransactions() {
    if (this.customerTransactionsLoading || this.customerTransactions.length > 0) {
      return;
    }

    this.customerTransactionsLoading = true;
    try {
      const response = await this.$request.get('/customer_transactions/read_options', { page: 0 });
      this.customerTransactions = _.get(response, 'data', response) || [];
    } finally {
      this.customerTransactionsLoading = false;
    }
  }

  calculateSalesAmount(row) {
    return (row.sales_line_items || []).reduce((sum, item) => {
      const lineAmount = new Decimal(item.price || 0).mul(item.quantity || 0);
      return sum.plus(lineAmount);
    }, new Decimal(0)).toFixed(2);
  }

  buildCreatePaymentReminders(row) {
    const stages = _.get(row, 'customer_transaction.stages', []);
    const salesAmount = Number(this.calculateSalesAmount(row));

    if (!stages.length || salesAmount <= 0) {
      return [];
    }

    const existingReminderMap = _.keyBy(this.sortPaymentReminders(row.payment_reminders || []), item => Number(item.stage_index));
    const amounts = allocateReminderAmounts(this.calculateSalesAmount(row), stages);

    return stages.map((percentage, index) => {
      const stageIndex = index + 1;
      const existingReminder = existingReminderMap[stageIndex] || {};

      return {
        ...existingReminder,
        stage_index: stageIndex,
        percentage,
        amount: amounts[index],
        date: existingReminder.date || '',
      };
    });
  }

  buildSubmitPaymentReminders(row) {
    if (row.id) {
      return this.sortPaymentReminders(row.payment_reminders || []).map(item => ({ ...item }));
    }

    return this.buildCreatePaymentReminders(row);
  }

  buildSubmitRow(row) {
    const body = _.cloneDeep(row);
    body.payment_reminders = this.buildSubmitPaymentReminders(body);
    delete body.customer_transaction_id;
    delete body.customer_transaction;
    return body;
  }

  handleAddSalesLineItem(rowIndex) {
    this.tableData[rowIndex].sales_line_items.push(this.getDefaultSalesLineItem());
  }

  handleRemoveSalesLineItem(rowIndex, index) {
    this.tableData[rowIndex].sales_line_items.splice(index, 1);
  }

  handleAddRow() {
    this.tableData.push(this.getDefaultRow());
  }

  handleRemoveRow(index) {
    this.tableData.splice(index, 1);
  }

  async handleSearchStyleNumber(salesLineItem) {
    const result = await this.$autoLoading(this.$request.get(`/feige/products/${salesLineItem.style_number}`, {}, { $alert: false, $loading: false }));
    salesLineItem.price = result.sales_price || 0;
    salesLineItem.quantity = result.min_order_qty || 0;
  }

  setSalesLineItems(row, result) {
    // 清空高亮状态
    row.sales_line_items.forEach(lineItem => {
      lineItem._highlights = [];
    });

    const groupedResult = _.groupBy(result, 'style_number');
    // 相同款号合并，数量相加
    const mergedResult = Object.keys(groupedResult).map(styleNumber => {
      const items = groupedResult[styleNumber];
      return {
        style_number: styleNumber,
        quantity: _.sumBy(items, 'quantity'),
        price: _.get(items, '0.price', 0),
      };
    });
    if (row.sales_line_items && row.sales_line_items.length) {
      mergedResult.forEach(resultItem => {
        const existIndex = row.sales_line_items.findIndex(item => String(item.style_number).trim() === String(resultItem.style_number).trim());
        if (existIndex === -1) {
          row.sales_line_items.push({ ...resultItem, _highlights: ['style_number', 'quantity', 'price'] });
        } else {
          const existItem = row.sales_line_items[existIndex];
          const highlightFields = [];
          if (existItem.quantity !== resultItem.quantity) {
            highlightFields.push('quantity');
          }
          if (Number(existItem.price) !== Number(resultItem.price)) {
            highlightFields.push('price');
          }
          if (highlightFields.length > 0) {
            Object.assign(existItem, { ...resultItem, _highlights: highlightFields });
          }
        }
      });
      return;
    }
    this.$set(row, 'sales_line_items', mergedResult);
  }

  autoFillConfirmText = '已填写销售订单商品，是否追加填充（相同款号会覆盖）';

  // 自动填充销售订单商品
  async autoFillSalesLineItems(row, lineItems) {
    if (row.sales_line_items && row.sales_line_items.length) {
      await this.$confirm(this.autoFillConfirmText, '提示', { type: 'warning' });
    }

    if (lineItems && lineItems.length > 0) {
      this.setSalesLineItems(row, lineItems);
      return;
    }

    const ids = _.get(row, 'jushuitan_order_ids', []);
    if (ids.length !== 0) {
      const result = await this.$autoLoading(this.$request.post('/jushuitan_orders/sales_line_items', { ids }));
      this.setSalesLineItems(row, result.items || []);
    }
  }

  async handleShowJushuitanAfterSaleOrderDialog(rowIndex) {
    this.jushuitanAfterSaleOrderDialogRowIndex = rowIndex;
    this.jushuitanAfterSaleOrderIds = [];
    this.showJushuitanAfterSaleOrderDialog = true;
  }

  async autoFillSalesLineItemsByAfterSaleOrder() {
    const row = this.tableData[this.jushuitanAfterSaleOrderDialogRowIndex];
    if (!row) {
      return;
    }
    if (row.sales_line_items && row.sales_line_items.length) {
      await this.$confirm(this.autoFillConfirmText, '提示', { type: 'warning' });
    }
    const { data: jushuitanAfterSaleOrders } = await this.$autoLoading(
      this.$request.get('/jushuitan_after_sales/read_options', { id_in: this.jushuitanAfterSaleOrderIds, per_page: 99 })
    );
    const result = _.flatten(
      jushuitanAfterSaleOrders.map(order => {
        return order.items.map(item => {
          return {
            style_number: item.i_id || '',
            quantity: (item.qty || 0) * -1,
            price: item.price,
          }
        });
      })
    );
    this.setSalesLineItems(row, result);
    this.showJushuitanAfterSaleOrderDialog = false;
  }

  handleCustomerChange(rowIndex) {
    // 清空聚水潭订单
    this.tableData[rowIndex].jushuitan_order_ids = [];
    // 清空售后订单
    this.tableData[rowIndex].source_id = '';

    if (!this.tableData[rowIndex].customer_id) {
      this.handleCustomerTransactionChange(rowIndex, '');
    }
  }

  async applyCustomerTransaction(rowIndex, customerTransactionId) {
    const row = this.tableData[rowIndex];

    if (!row) {
      return;
    }

    if (!customerTransactionId) {
      this.$set(row, 'customer_transaction_id', '');
      this.$set(row, 'customer_transaction', null);
      this.$set(row, 'payment_reminders', []);
      return;
    }

    await this.loadCustomerTransactions();
    const customerTransaction = this.getCustomerTransactionById(customerTransactionId);

    this.$set(row, 'customer_transaction_id', customerTransactionId);
    this.$set(row, 'customer_transaction', customerTransaction);
    this.$set(row, 'payment_reminders', this.buildCreatePaymentReminders({
      ...row,
      customer_transaction: customerTransaction,
    }));
  }

  async handleCustomerSelect(rowIndex, customer) {
    if (this.isEdit) {
      return;
    }

    await this.applyCustomerTransaction(rowIndex, _.get(customer, 'customer_transaction_id', ''));
  }

  async handleCustomerTransactionChange(rowIndex, customerTransactionId) {
    const row = this.tableData[rowIndex];

    if (!row) {
      return;
    }

    if (!customerTransactionId) {
      this.$set(row, 'customer_transaction_id', '');
      this.$set(row, 'customer_transaction', null);
      this.$set(row, 'payment_reminders', []);
      return;
    }

    await this.loadCustomerTransactions();
    const customerTransaction = this.getCustomerTransactionById(customerTransactionId);

    this.$set(row, 'customer_transaction_id', customerTransactionId);
    this.$set(row, 'customer_transaction', customerTransaction);
    this.$set(row, 'payment_reminders', this.buildCreatePaymentReminders({
      ...row,
      customer_transaction: customerTransaction,
    }));
  }

  handlePaymentRemindersChange(rowIndex, paymentReminders) {
    const row = this.tableData[rowIndex];

    if (!row) {
      return;
    }

    this.$set(row, 'payment_reminders', this.sortPaymentReminders(paymentReminders));
  }

  async onCreate(row) {
    const body = this.buildSubmitRow(row);
    await this.checkSimilar(body);
    await this.$request.post('/sales_orders', body);
  }

  async onUpdate(row) {
    const originData = this.value;
    const body = this.buildSubmitRow(row);
    // 保留原数据中的相同款号已有字段
    const originSalesLineItemsKeyByStyleNumber = _.keyBy(originData.sales_line_items, 'style_number');
    body.sales_line_items = body.sales_line_items.map(item => {
      const originItem = originSalesLineItemsKeyByStyleNumber[item.style_number];
      if (originItem) {
        return {
          ...originItem,
          ...item,
        }
      }
      return item;
    });
    // 删除了的加_destroy: true
    const saleLineItemsKeyById = _.keyBy(body.sales_line_items.filter(item => item.id), 'id');
    originData.sales_line_items.forEach(item => {
      if (!saleLineItemsKeyById[item.id]) {
        body.sales_line_items.push({ ...item, _destroy: true });
      }
    });
    await this.$request.put(`/sales_orders/${this.value.id}`, body);
  }

  async onSubmit(row) {
    if (row.id) {
      await this.onUpdate(row);
    } else {
      await this.onCreate(row);
    }
  }

  async onValidate(row) {
    const descriptor = {
      ordered_on: { type: 'date', required: true, message: '请选择下单日期' },
      kind: { required: true, message: '请选择订单类型' },
      product_type: { required: true, message: '请选择产品类型' },
      business_kind: { required: true, message: '请选择业务类型' },
      customer_id: { required: true, message: '请选择客户' },
      customer_transaction_id: { required: !row.id, message: '请选择交易方式' },
      is_transfer_existing: { required: true, message: '请选择是否调拨现货' },
      source_id: { required: row.kind === 'after_sale', message: '请选择售后订单' },
      sales_line_items: {
        type: 'array',
        required: true,
        message: '请添加销售订单商品',
        defaultField: {
          type: 'object',
          required: true,
          message: '请添加销售订单商品',
          fields: {
            style_number: { type: 'string', required: true, message: '请输入款号' },
            quantity: { type: 'any', required: true, message: '请输入数量' },
            price: { type: 'any', required: true, message: '请输入价格' },
          },
        },
      },
    }
    const validator = new Schema(descriptor);
    await validator.validate(row);

    const paymentReminders = this.buildSubmitPaymentReminders(row);
    const salesAmount = Number(this.calculateSalesAmount(row));
    if (!row.id && paymentReminders.length === 0 && salesAmount > 0) {
      throw { errors: [{ message: '请选择交易方式并生成付款提醒' }] };
    }
    paymentReminders.forEach((item) => {
      if (!item.date) {
        throw { errors: [{ message: `请填写阶段${item.stage_index}的付款日期` }] };
      }
    });
  }

  async checkSimilar(row) {
    try {
      await this.$request.post('/sales_orders/check_similar', row, { $loading: false, $alert: false });
    } catch (error) {
      const code = _.get(error, 'api_code');
      if (code === 40000) {
        const errorMsg = _.get(error, 'message');
        await this.$confirm(`第1条订单 - ${errorMsg}`, '提示', { type: 'warning', confirmButtonText: '继续创建', cancelButtonText: '取消' });
      } else {
        throw error;
      }
    }
  }

  async handleSubmit() {
    const resultArr = await Promise.allSettled(this.tableData.map((row) => this.onValidate(row)));
    const errorMessages = [];
    resultArr.forEach((result, index) => {
      if (result.status === 'rejected') {
        result.reason.errors.forEach((error) => {
          errorMessages.push(`第${index + 1}条订单: ${error.message}`);
        });
      }
    });
    if (errorMessages.length > 0) {
      this.$msgbox({
        title: '错误',
        message: this.$createElement('div', {
          style: 'white-space: pre-wrap;'
        }, _.uniq(errorMessages).join('\n'))
      });
      return;
    }
    this.submitting = true;
    const tableDataSubmit = _.cloneDeep(this.tableData)
    tableDataSubmit.forEach(i => {
      delete i.key;
    });
    try {
      for (const [index, row] of tableDataSubmit.entries()) {
        await this.onSubmit(row);
        // 成功后删掉成功那条
        this.tableData.splice(index, 1);
      }
      this.$message.success('操作成功');
      this.dialogVisible = false;
      this.$emit('success');
    } finally {
      this.submitting = false;
    }
  }

  handleOpenFeigeNumbersDialog() {
    this.feigeNumbers = [];
  }

  async handleSubmitFeigeNumbers() {
    const data = await this.$autoLoading(this.$request.get('/sales_orders/from_feige_orders', { numbers: this.validFiegeNumbers }));
    this.showFeigeNumbersDialog = false;
    if (data) {
      this.defaultRowFromFeige = { ...data };
    } else {
      this.defaultRowFromFeige = null;
    }
    this.dialogVisible = true;
  }

  handleKindChange(rowIndex, kind) {
    if (kind === 'after_sale') {
      // 售后订单时，清空聚水潭订单
      this.tableData[rowIndex].jushuitan_order_ids = [];
      // 打开售后订单选择弹窗
      this.showAfterSaleOrderDialog = true;
      this.afterSaleOrderDialogRowIndex = rowIndex;
    } else {
      // 非售后订单时，清空售后订单
      this.tableData[rowIndex].source_id = '';
    }
  }

  displaySalesOrderText(salesOrder) {
    return `销售单号: ${salesOrder.number} - 销售金额: ${salesOrder.sales_amount}`
  }

  displayJushuitanAfterSaleOrderText(jushuitanAfterSaleOrder) {
    return `平台退货退款单号: ${jushuitanAfterSaleOrder.outer_as_id} - 线上单号: ${jushuitanAfterSaleOrder.so_id} - 退款金额: ${jushuitanAfterSaleOrder.refund}`
  }

  async handleSelectedAfterSaleOrder(salesOrder) {
    if (salesOrder) {
      await this.$nextTick();
      Object.assign(this.tableData[this.afterSaleOrderDialogRowIndex], {
        ..._.pick(salesOrder, ['product_type', 'ordered_on', 'is_transfer_existing', 'customer_id']),
        source_id: salesOrder.id,
        jushuitan_order_ids: [],
      });
      // 让customer_id的read_options组件重新渲染
      this.$set(this.tableData[this.afterSaleOrderDialogRowIndex], '_customer_id_key', String(Date.now()));
      // 让source_id的read_options组件重新渲染
      this.$set(this.tableData[this.afterSaleOrderDialogRowIndex], '_source_id_key', String(Date.now()));
      if (!this.isEdit) {
        await this.applyCustomerTransaction(this.afterSaleOrderDialogRowIndex, _.get(salesOrder, 'customer.customer_transaction_id', ''));
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.highlight {
  background-color: #fcd; // 更浅的颜色
}
</style>
